/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Display_Next_Calls_LabelInputs */

const fr_settings_display_next_calls_label = /** @type {(inputs: Settings_Display_Next_Calls_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prochains passages`)
};

const en_settings_display_next_calls_label = /** @type {(inputs: Settings_Display_Next_Calls_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upcoming stops`)
};

/**
* | output |
* | --- |
* | "Upcoming stops" |
*
* @param {Settings_Display_Next_Calls_LabelInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_display_next_calls_label = /** @type {((inputs?: Settings_Display_Next_Calls_LabelInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Display_Next_Calls_LabelInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_settings_display_next_calls_label(inputs)
	return en_settings_display_next_calls_label(inputs)
});